import create from 'zustand';
import { ExtendedInspectType } from '@/app/_components/services/result-list/chip-selector/ChipSelector';

interface QueryParamsStoreType {
  selectedFilter: ExtendedInspectType;
  currentPage: number;
  setSelectedFilter: (type: ExtendedInspectType) => void;
  setCurrentPage: (page: number) => void;
  handleFilterClick: (type: ExtendedInspectType) => void;
  handlePageChange: (page: number) => void;
}

export const useQueryParamsStore = create<QueryParamsStoreType>((set) => ({
  selectedFilter: 'all',
  currentPage: 1,
  setSelectedFilter: (type) => set({ selectedFilter: type }),
  setCurrentPage: (page) => set({ currentPage: page }),

  handleFilterClick: (type) => {
    set({ selectedFilter: type });
  },

  handlePageChange: (page) => {
    set({ currentPage: page });
  },
}));
